import { Node } from '@tiptap/core'

export const Div = Node.create({
  name: 'div',
  group: 'block',
  content: 'block*',
  defining: true,
  addAttributes() {
    return {
      id: { default: null },
      align: { default: null },
      class: { default: null },
      style: { default: null }
    }
  },
  parseHTML() {
    return [{ tag: "div" }]
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", HTMLAttributes, 0]
  },
})